import { createContext } from 'react';

export type StepStateValue = {
  /**
   * A locked step cannot be expanded, so its form and Save action are out of
   * reach. Used by the employee onboarding page, where steps must be completed
   * in order; the admin flow leaves this false and can save any step.
   */
  locked: boolean;
  /** Shown next to the step title to explain why it is locked. */
  lockedHint?: string;
  /**
   * This step's save is in flight. StepCard turns its actions into a loading
   * state so the feedback sits on the button the user pressed rather than on a
   * page-wide overlay.
   */
  submitting?: boolean;
  /**
   * Start expanded instead of collapsed. Used for the step the user is up to, so
   * the employee flow opens on the next thing to fill in rather than making them
   * hunt for it. The user can still collapse it.
   */
  autoExpand?: boolean;
};

const StepStateContext = createContext<StepStateValue>({ locked: false });

export default StepStateContext;
